export const COMMUNITY_ID = "communityId";
export const YEAR = "budgetYear";
export const BILLING_CATEGORY = "billingCategoryIds";
export const TRANSACTION_TYPE = "transactionType";
export const AUTO_BILLING = "autoBilling";
export const ACCOUNT_NUMBER = "glAccountId";
export const FREQUENCY = "frequency";
export const AMOUNT = "amount";
export const INTEREST = "interestPercentage";
export const CURRENCY = "currency";
export const BILLING_DATE = "billingRunDate";
export const DUE_DATE = "dueDate";
export const POSTING_DATE = "postingDate";
export const DESCRIPTION = "transactionDescription";
export const PAYMENT_TERM = "paymentTermId";
export const MONTHLY_BILLING_DATE = "monthlyBillingDay";
export const MONTHLY_POSTING_DATE = "monthlyPostingDay";
export const PROPERTY_MODEL_ID = "propertyModelId";
export const PROPERTY_CATEGORY_ID = "propertyCategoryId";
export const PROPERTY_IDS = "billingCategoryPropertyIds";
export const LINE_ITEM_TYPE="lineItemType";
